module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-wechat-jssdk-467.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/wechat/vue-wechat-jssdk.md
// module id = 930
// module chunks = 212